/**
 * Navigation Utilities
 * Handles page navigation, transitions, and URL updates with debouncing
 */

/**
 * Update the document title
 * @param {string} title - The title to set
 */
export function updateDocumentTitle(title) {
    if (title && title.trim()) {
        document.title = title;
    } else {
        document.title = 'Engryv';
    }
}

/**
 * Navigate to a slug with cinematic transition effect
 * Includes debouncing to prevent duplicate navigation attempts
 * 
 * @param {string} slug - The route slug (e.g., 'home', 'about', 'products')
 * @requires window.Engryv.appViewModel - Must be initialized
 */
export function cinematicNav(slug) {
    if (!window.Engryv || !window.Engryv.appViewModel) return;
    
    // Check if already on this page
    if (window.Engryv.appViewModel.currentViewSlug() === slug) {
        return;
    }
    
    // Check if already pending navigation to the same slug
    if (window.Engryv.appViewModel.pendingSlug() === slug) {
        return;
    }
    
    // Cancel any existing pending navigation
    const existingTimeoutId = window.Engryv.appViewModel.pendingNavigation();
    if (existingTimeoutId) {
        clearTimeout(existingTimeoutId);
    }
    
    window.Engryv.appViewModel.pendingSlug(slug);
    const timeoutId = setTimeout(function() {
        window.location.hash = '#/' + slug;
        window.Engryv.appViewModel.pendingNavigation(null);
        window.Engryv.appViewModel.pendingSlug(null);
    }, 350);
    window.Engryv.appViewModel.pendingNavigation(timeoutId);
}

/**
 * Navigate to a product with cinematic transition effect
 * Updates the URL and triggers a popstate event for history handling
 * Uses 550ms timing to ensure fade-out completes before fade-in starts
 * (CSS transition is 500ms, added 50ms buffer)
 * 
 * @param {string} targetHash - The target product hash (e.g., 'product/pejas')
 * @requires window.Engryv.appViewModel - Must have isTransitioning() method
 */
export function cinematicProductNav(targetHash) {
    if (window.Engryv && window.Engryv.appViewModel && typeof window.Engryv.appViewModel.isTransitioning === 'function') {
        window.Engryv.appViewModel.isTransitioning(true);
        setTimeout(function() {
            window.history.pushState({}, '', '/' + targetHash.replace(/^\/?/, ''));
            window.dispatchEvent(new PopStateEvent('popstate'));
        }, 550);
    } else {
        window.history.pushState({}, '', '/' + targetHash.replace(/^\/?/, ''));
        window.dispatchEvent(new PopStateEvent('popstate'));
    }
}
